// utils/formatDate.js

/**
 * Преобразует дату из формата YYYY-MM-DD в формат "ДД Месяц(на польском) ГГГГ"
 * @param {string} dateString - дата в формате "2026-08-18"
 * @returns {string} - дата в формате "18 sierpnia 2026"
 */
export const formatDate = (dateString) => {
    if (!dateString) return '';
    
    const months = [
        'stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
        'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'
    ];
    
    const parts = dateString.split('-');
    const month = parseInt(parts[1], 10) - 1;
    const day = parseInt(parts[2], 10);
    
    return `${day} ${months[month]}`;
};

/**
 * Преобразует дату из формата YYYY-MM-DD в формат "ДД/ММ/ГГГГ"
 */
export const formatDateSlash = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    return `${parts[2]}/${parts[1]}/${parts[0]}`;
};

/**
 * Преобразует дату из формата YYYY-MM-DD в формат "ДД-ММ-ГГГГ"
 */
export const formatDateDash = (dateString) => {
    if (!dateString) return '';
    const parts = dateString.split('-');
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
};

/**
 * Возвращает название месяца на польском (в именительном падеже)
 */
export const getMonthName = (monthNumber) => {
    const months = [
        'styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec',
        'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień'
    ];
    return months[monthNumber] || '';
};

/**
 * Возвращает день недели на польском
 */
export const getDayOfWeek = (dateString) => {
    if (!dateString) return '';
    const days = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
    const date = new Date(dateString);
    return days[date.getDay()];
};